<template>
  <van-popup class="states-pop" :close-on-click-overlay="unClose" v-model="pop_state">
    <div class="ttl">
      <span v-if="msgpms.msgcode === 'MSG006' || msgpms.msgcode === 'MSG008'">{{ msgpms.msgtext }}</span>
      <span v-else>{{ code_map[msgpms.msgcode] }}</span>
    </div>
    <div class="content">
      <div v-if="msgpms.start_at && msgpms.end_at" class="time">
        活动时间：{{ msgpms.start_at }} 至 {{ msgpms.end_at }}
      </div>
      <!-- <div v-if="msgpms.msgtext" class="text">
        {{ msgpms.msgtext }}
      </div> -->
    </div>
    <div class="footer">
      <wx-open-launch-weapp
        id="launch-btn_tl2"
        username="gh_5ab77bce3fc8"
        path="/pages/index/home"
        v-if="isWxH5 && (isMantuCustomization && !(msgpms.msgcode === 'MSG006' && msgpms.btntext)) && env !== 'wx'"
      >
        <script type="text/wxtag-template">
          <style>
          .jump-btn {
          width: 100%;
          height: 42px;
          line-height: 42px;
          margin: 0 auto;
          margin-top: 32px;
          font-size: 15px;
          font-weight: 500;
          text-align: center;
          background: linear-gradient(270deg, #1a7785 0%, #52a6b3 100%);
          border: 1px solid #ebedf0;
          border-radius: 42px;
          color: white;
          box-sizing: border-box;
          }
          </style>
          <div class="jump-btn">去缦图摄影看看</div>
        </script>
      </wx-open-launch-weapp>
      <van-button
        @click="linksGo"
        class="line-btn"
        block
        v-else
      >
        <span v-if="msgpms.msgcode === 'MSG006' && msgpms.btntext">{{ msgpms.btntext }}</span>
        <template v-else>
          <span v-if="brand === 'himo'">去{{ isMantuCustomization ? '缦图摄影' : '海马体' }}看看</span>
          <span v-if="brand === 'family'">
            <span v-if="env === 'h5'">我知道了</span>
            <span v-else>去海马体 Family 看看</span>
          </span>
          <span v-if="brand === 'kids'">去海马体儿童看看</span>
        </template>
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import { isWxEnv } from '../../../utils/index'

export default {
  props: {
    brand: {
      type: String,
      default: 'himo'
    },
    msgpms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isMantuCustomization: Boolean
  },
  data () {
    return {
      pop_state: false,
      code_map: {
        MSG001: '活动已经下线啦，下次再来吧~',
        MSG002: '活动还未上线哦~',
        MSG003: '哎呀好可惜，奖券被领完啦~',
        MSG004: '您已经领取过优惠券了哦~',
        MSG005: '链接失效了哦~',
        MSG006: '您还不能领取哦~',
        MSG007: '券已经被领完了哦，下次再来吧~'
      },
      isWxH5: isWxEnv()
    }
  },
  computed: {
    unClose: function () {
      return !(this.msgpms.msgcode === 'MSG005')
    },
    ...mapState(['env'])
  },
  methods: {
    linksGo () {
      this.pop_state = false
      if (this.msgpms.msgcode === 'MSG006' && this.msgpms.poplink) {
        this.goLinks({ link: this.msgpms.poplink, isMantuCustomization: this.isMantuCustomization })
      } else if (!(this.env === 'h5' && this.brand === 'family')) {
        this.goLinks({ isMantuCustomization: this.isMantuCustomization })
      }
    }
  }
}
</script>

<style lang="less" scoped>

.states-pop {
  width: 320px;
  padding: 20px;
  text-align: center;
  border-radius: 12px;

  .ttl {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
  }

  .content {
    min-height: 20px;
  }

  .time,
  .text {
    margin-top: 20px;
    font-size: 14px;
    line-height: 18px;
    color: #a1a1a1;
  }

  .footer {
    display: flex;
    margin-top: 30px;
  }
}

</style>
